import { useEffect } from "react";

import { Log, recaptchaEnterpriseSiteKey } from "@ryde/shared";

import { useLoginTranslation } from "../use-login-translation";

const RECAPTCHA_URL = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaEnterpriseSiteKey()}`;

export const RecaptchaEnterprise = (): null => {
  const { t } = useLoginTranslation();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = RECAPTCHA_URL;
    script.async = true;

    script.onload = function () {
      // Now global object window.grecaptcha available
      Log.info(t("login.RECAPTCHA_LOADED"));
    };

    document.head.appendChild(script);
  }, [t]);
  return null;
};
